import { createContext } from "react";
import { IDonorEligibilityDate } from "../../../services/bexWISE/donorDataService/IDonorDataService";
import { IDonorDTO } from "../../../types/IDonorDTO";
import { tr } from "date-fns/locale";

export interface IUserContext {
   loading: boolean;
   userDonorId: string | null;
   eligibilityDates: IDonorEligibilityDate[] | null;
   profileData: IDonorDTO | null;
}

export const defaultUserContext: IUserContext = {
   loading: true,
   userDonorId: null,
   eligibilityDates: null,
   profileData: null,
};

export const UserContext = createContext<IUserContext>(defaultUserContext);
